'use client';

export { default } from './Chip';
export { default as chipClasses } from './chipClasses';
export * from './chipClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Chip/index.js
// module id = 416
// module chunks = 22